import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.6 2.35a5 5 0 0 0-4.66 3.16.82.82 0 0 0-.22 0 3.44 3.44 0 0 0-.78 6.8.52.52 0 0 0 .17 0 .75.75 0 0 0 .17-1.48 1.93 1.93 0 0 1-1.51-1.89A2 2 0 0 1 4.72 7a1.66 1.66 0 0 1 .49.07.7.7 0 0 0 .25 0h.08a.76.76 0 0 0 .65-.56 3.51 3.51 0 1 1 5.2 3.89.75.75 0 0 0 .39 1.39.75.75 0 0 0 .38-.1A5 5 0 0 0 9.6 2.35Zm.81 8.56a.76.76 0 0 1-.69.45h-1v1.82a.75.75 0 1 1-1.5 0v-1.82h-1a.75.75 0 0 1-.55-1.26l1.72-1.92a.73.73 0 0 1 .4-.18.76.76 0 0 1 .3 0 .73.73 0 0 1 .4.22l1.78 1.92a.74.74 0 0 1 .14.77Z';
const draw24px =
  'M15.52,15.81A.78.78,0,0,1,15,16a.72.72,0,0,1-.55-.24l-1.71-1.85V19.6a.75.75,0,0,1-1.5,0V13.92L9.54,15.77a.76.76,0,0,1-1.06,0,.74.74,0,0,1,0-1.06l3-3.25a.76.76,0,0,1,.55-.24.77.77,0,0,1,.55.24l3,3.25A.76.76,0,0,1,15.52,15.81ZM14.79,3.44A7.94,7.94,0,0,0,7.27,8.8a5.81,5.81,0,0,0-.72-.05,5.3,5.3,0,0,0,0,10.6.75.75,0,1,0,0-1.5,3.8,3.8,0,1,1,1-7.48.65.65,0,0,0,.31,0,.75.75,0,0,0,.72-.57,6.46,6.46,0,1,1,8.21,7.74.77.77,0,0,0-.49.95A.75.75,0,0,0,17,19a.57.57,0,0,0,.22,0,8,8,0,0,0-2.4-15.54Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CloudUpArrowIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'cloudUpArrow'),
) as IconWithRender;

CloudUpArrowIcon.displayName = 'CloudUpArrowIcon';
CloudUpArrowIcon.propTypes = Icon.propTypes;
CloudUpArrowIcon.renderIcon = (props) => <CloudUpArrowIcon {...props} />;
export default CloudUpArrowIcon;
